import { inject, Pipe, PipeTransform } from '@angular/core';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { ObjectPath } from '@bo-client/shared/types/ObjectPath.type';
import { NBPConfig } from '@bo-client/shared/config.model';

@Pipe({
  name: 'tenantConfigPipe$',
  pure: false
})
export class TenantConfigPipe implements PipeTransform {
  private dataShareService = inject(DataShareService);

  transform(path: ObjectPath<NBPConfig> | string, fallBackValue?: unknown) {
    return this.dataShareService.getSingleTenantConfig$(path, fallBackValue);
  }
}
